import React from 'react'
import styled from 'styled-components'
import ImageContainer from 'views/Home/components/ImageContainer'
import ManWithWolfHead from '../../../components/Svg/ManWithWolfHead'
import SmallMoney from '../../../components/Svg/SmallMoney'
import YellowCircleSticker from '../../../components/Svg/YellowCircleSticker'
import Pen from '../../../components/Svg/Pen'
import Ellipse from '../../../components/Svg/Ellipse'

const Triangle = () => (
  <svg width="26" height="15" viewBox="0 0 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.1447 13.6217L2.64805 0.949235L24.0164 1.17844L14.1447 13.6217Z" stroke="white" strokeWidth="1.51148" />
  </svg>
)

const RedTriangle1 = () => (
  <svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.7302 38L0 15.3946L32 0L14.7302 38Z" fill="#DE523E" />
  </svg>
)

const RedTriangle2 = () => (
  <svg width="55" height="49" viewBox="0 0 55 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.5447 0L55 36.9649L0 49L28.5447 0Z" fill="#DE523E" />
  </svg>
)

export default function MobileBackgroundWrapper() {
  return (
    <>
      <ImageContainer top="-30px" left="-25px" zindex="-2">
        <RedTriangle1 />
      </ImageContainer>
      <ImageContainer top="525px" right="-25px" zindex="-3">
        <RedTriangle2 />
      </ImageContainer>
      <ImageContainer top="550px" left="-32px" zindex="-2">
        <ManWithWolfHead size="small" />
      </ImageContainer>
      <ImageContainer top="450px" left="20px" zindex="-3" rotate="rotate(-90deg)">
        <YellowCircleSticker width="166" height="166" viewBox="0 0 166 166" />
      </ImageContainer>
      <ImageContainer top="-10px" left="-50px" zindex="-2">
        <SmallMoney width="103" height="114" viewBox="0 0 103 114" />
      </ImageContainer>
      <ImageContainer top="745px" right="0" zindex="-1">
        <Pen width="88" height="40" viewBox="0 0 88 40" />
      </ImageContainer>
      <ImageContainer top="520px" left="50%" zindex="-2">
        <Triangle />
      </ImageContainer>
    </>
  )
}
